import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from "react-error-boundary";

export const Prepa = (props) => {
    const navigate = useNavigate();
    const [openNursing, setOpenNursing] = useState(false);
    const [openEmt, setOpenEmt] = useState(false);
    const [openMed, setOpenMed] = useState(false);
    const [openPhlebotomy, setOpenPhlebotomy] = useState(false);
    const [openNP, setOpenNP] = useState(false);
    const [openMSN, setOpenMSN] = useState(false);

    const handleTrackNavigate = (track) => {
        navigate(`/${track}`);
    };

    const styles = {
        container: {
            backgroundColor: "#d7ffd9",
            color: "#1b5e20",
            minHeight: "100vh",
            padding: "30px",
            paddingTop: "100px"
        },
        sectionWrapper: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "30px",
        },
        section: {
            flex: "1 1 calc(50% - 20px)",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            textAlign: "left",
        },
        calendarSection: {
            flex: "1 1 100%",
            backgroundColor: "#c8e6c9",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            textAlign: "center"
        },
        sectionTitle: {
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#1b5e20",
            marginBottom: "15px",
        },
        sectionText: {
            fontSize: "1.2rem",
            lineHeight: "1.5",
            color: "#2e7d32",
            marginBottom: "20px",
        },
        iframe: {
            border: "none",
            width: "100%",
            maxWidth: "800px",
            height: "600px",
            borderRadius: "10px",
            boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
        },
        footer: {
            marginTop: "30px",
            textAlign: "center",
            fontSize: "1rem",
            color: "#388e3c",
            fontWeight: "bold",
        },
        trackButtonsWrapper: {
            display: "flex",
            gap: "12px",
            marginBottom: "30px",
            justifyContent: "flex-start",
            flexWrap: "wrap",
        },
        trackButton: {
            padding: "6px 14px",
            borderRadius: "8px",
            border: "2px solid #2e7d32",
            backgroundColor: "transparent",
            color: "#1b5e20",
            fontSize: "1.15rem",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.2s ease",
        },
        trackButtonActive: {
            padding: "6px 14px",
            borderRadius: "8px",
            border: "2px solid #1b5e20",
            backgroundColor: "#2e7d32",
            color: "white",
            fontSize: "1.15rem",
            fontWeight: 600,
            cursor: "default",
        },
    };

    return (
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <div style={styles.container}>
                <h1 style={{ marginTop: 0, marginBottom: "20px", fontSize: "2.25rem", color: "#1b5e20", fontWeight: "bold", textTransform: "uppercase" }}>Pre-Physician Assistant</h1>
                {/* Track Navigation Buttons */}
                <div style={styles.trackButtonsWrapper}>
                    <button
                        onClick={() => handleTrackNavigate('premed')}
                        style={styles.trackButton}
                    >
                        Pre-Med
                    </button>
                    <button
                        onClick={() => handleTrackNavigate('predent')}
                        style={styles.trackButton}
                    >
                        Pre-Dent
                    </button>
                    <button
                        onClick={() => handleTrackNavigate('prepa')}
                        style={styles.trackButtonActive}
                        aria-current="page"
                    >
                        Pre-PA
                    </button>
                </div>

                {/* Calendar Section */}
                <section style={styles.calendarSection}>
                    <h2 style={styles.sectionTitle}>Calendar</h2>
                    <p style={styles.sectionText}>
                        Check upcoming events, workshops, and meetings related to Pre-PA opportunities.
                    </p>
                    <div style={{ transform: "scale(0.9)", transformOrigin: "top center" }}>
                        <iframe
                            src="https://calendar.google.com/calendar/embed?src=c_699edc953ca8cf13d457530e1e112b5e7e46c4dab359de94e7f71db134e0fd16%40group.calendar.google.com&ctz=America%2FNew_York"
                            style={styles.iframe}
                            title="PrePA Calendar"
                        ></iframe>
                    </div>
                </section>

                {/* Opportunities and Certifications */}
                <div style={styles.sectionWrapper}>
                    <section style={styles.section}>
                        <h2 style={styles.sectionTitle}>Opportunities</h2>
                        <p style={styles.sectionText}>
                            Discover shadowing programs, clinical internships, and volunteer
                            opportunities to enhance your Pre-PA experience.
                        </p>
                    </section>

                    <section style={styles.section}>
                        <h2 style={styles.sectionTitle}>Certifications</h2>
                        <p style={styles.sectionText}>The following certifications are <strong>highly recommended</strong> for the PA track — these are the top certifications for building Patient Care hours required for PA school admissions.</p>

                        {/* CNA & Patient Care Technician */}
                        <button
                            onClick={() => setOpenNursing(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Certified Nursing Assistant (CNA) &amp; Patient Care Technician</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openNursing ? "▲" : "▼"}</span>
                        </button>
                        {openNursing && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                {props.data
                                    ? props.data.PrePACert.nursing.map((d, i) => (
                                        <div key={`${d.name}-${i}`}>
                                            <h4><a href={d.link}>{d.name}</a></h4>
                                        </div>
                                    ))
                                    : "Loading..."}
                            </div>
                        )}

                        {/* EMT */}
                        <button
                            onClick={() => setOpenEmt(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Emergency Medical Technician (EMT)</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openEmt ? "▲" : "▼"}</span>
                        </button>
                        {openEmt && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                {props.data
                                    ? props.data.PrePACert.emt.map((d, i) => (
                                        <div key={`${d.name}-${i}`}>
                                            <h4><a href={d.link}>{d.name}</a></h4>
                                        </div>
                                    ))
                                    : "Loading..."}
                            </div>
                        )}

                        {/* Medical Assistant */}
                        <button
                            onClick={() => setOpenMed(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Medical Assistant Certification</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openMed ? "▲" : "▼"}</span>
                        </button>
                        {openMed && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                {props.data
                                    ? props.data.PrePACert.med.map((d, i) => (
                                        <div key={`${d.name}-${i}`}>
                                            <h4><a href={d.link}>{d.name}</a></h4>
                                        </div>
                                    ))
                                    : "Loading..."}
                            </div>
                        )}

                        {/* Phlebotomy */}
                        <button
                            onClick={() => setOpenPhlebotomy(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Phlebotomy</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openPhlebotomy ? "▲" : "▼"}</span>
                        </button>
                        {openPhlebotomy && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li><a href="https://www.nha.com">National Healthcareer Association (NHA)</a></li>
                                    <li><a href="https://americanmedtech.org/certification/get-certified">American Medical Technologists (AMT)</a></li>
                                    <li><a href="https://www.ncctinc.com/certifications/phlebotomy-technician">National Center for Competency Testing (NCCT)</a></li>
                                    <li><a href="https://www.massbay.edu/academics/health-sciences/phlebotomy">MassBay Community College (Wellesley and Framingham location)</a></li>
                                    <li><a href="https://www.stcc.edu/wdc/descriptions/wphl-001-phlebotomy-technician-certificate/">Springfield Technical Community College</a></li>
                                </ul>
                            </div>
                        )}

                        {/* Nurse Practitioner */}
                        <button
                            onClick={() => setOpenNP(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Nurse Practitioner (NP)</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openNP ? "▲" : "▼"}</span>
                        </button>
                        {openNP && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li><a href="https://absn.felician.edu/blog/becoming-a-nurse-practitioner-with-a-non-nursing-bachelors-degree/">How to become an NP with a non-nursing bachelor's</a></li>
                                    <li><a href="https://absn.felician.edu/blog/becoming-a-nurse-practitioner-with-a-non-nursing-bachelors-degree/">How to become an NP with a BSN</a></li>
                                    <li><a href="https://www.aanp.org/news-feed/explore-the-variety-of-career-paths-for-nurse-practitioners">Path to becoming an NP (step-by-step guide)</a></li>
                                </ul>
                            </div>
                        )}

                        {/* MSN */}
                        <button
                            onClick={() => setOpenMSN(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>MSN (Master of Science in Nursing)</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openMSN ? "▲" : "▼"}</span>
                        </button>
                        {openMSN && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li><a href="https://www.snhu.edu/about-us/newsroom/health/what-is-an-msn-degree">MSN program info</a></li>
                                    <li><a href="https://www.shawnee.edu/blog/benefits-of-msn-degree-why-pursue-your-msn">What MSN offers</a></li>
                                </ul>
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </ErrorBoundary>
    );
};
